<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <div class="relative h-full transition-all duration-500 " :class="((open || isMainPage) && !searchOpen) && isMainPage ?'w-80':'w-18'">
    <menu id="jump-navigation" role="navigation" :aria-label="$t('aria_labels.main_nav')"
      class="group absolute inset-y-0 z-50 flex shrink-0 cursor-context-menu flex-col justify-between space-x-8 overflow-hidden rounded-r-md bg-Blue-Secondary pb-4 text-White transition-[width]"
      :class="(open || isMainPage) && !searchOpen
        ? 'navigation-is-open w-80 duration-500' : 'w-18 duration-500'
        " :open="((open || isMainPage) && !searchOpen) ? true : null" @mouseleave="open = false"
      @mouseenter="open = true" @focusin="open = true" @focusout="open = false">
      <div class="flex h-full w-80 flex-col items-start justify-between pr-4">
        <div class="flex flex-col gap-4">
          <NuxtLink :to="localePath({ name: 'index' })" class="group/link flex items-center">
            <IconHomeLogo
              class="w-18 p-5.5 transition-all duration-200 group-open:translate-x-10 group-open:opacity-0" />
            <IconFullLogo
              class="pointer-events-none absolute mt-3 h-12 pl-5.5 opacity-0 transition-all duration-300 group-open:opacity-100" />
          </NuxtLink>

          <ul>
            <li class="flex items-center">
              <NuxtLink :to="localePath({ name: 'Medications' })" class="group/link flex items-center">
                <IconPill class="w-18 shrink-0 px-5.5 py-2" />
                <h2
                  class="text-base font-bold tracking-wide underline-offset-2 opacity-0 transition-opacity duration-300 group-open:opacity-100 group-hover/link:underline">
                  {{ $t('navigate.medication') }}
                </h2>
              </NuxtLink>
            </li>
          </ul>

          <ul>
            <li class="flex items-center">
              <NuxtLink :to="localePath({ name: 'ActiveIngredients' })" class="group/link flex items-center">
                <IconDrip class="w-18 shrink-0 px-5.5 py-2" />
                <h2
                  class="text-base font-bold tracking-wide underline-offset-2 opacity-0 transition-opacity duration-300 group-open:opacity-100 group-hover/link:underline">
                  {{ $t('navigate.active_ingredients') }}
                </h2>
              </NuxtLink>
            </li>
          </ul>

          <ul>
            <li class="flex items-center">
              <NuxtLink :to="localePath({ name: 'GeneralInformation' })" class="group/link flex items-center">
                <IconInfo class="w-18 shrink-0 px-5.5 py-2" />
                <h2
                  class="text-base font-bold tracking-wide underline-offset-2 opacity-0 transition-opacity duration-300 group-open:opacity-100 group-hover/link:underline">
                  {{ $t('navigate.general_information') }}
                </h2>
              </NuxtLink>
            </li>
            <div v-if="nav?.tree && nav?.tree.length > 0"
              class="pl-18 opacity-0 transition-opacity duration-300 group-open:opacity-100">
              <li v-for="{ page } in nav?.tree" :key="page?.id">
                <NuxtLink :to="localePath({
                  name: 'GeneralInformation',
                  hash: genID(page?.slug),
                })
                  " class="block py-1.5 text-xs leading-tight font-light hover:text-Blue-Primary">
                  {{ page.title }}
                </NuxtLink>
              </li>
            </div>
          </ul>
        </div>

        <ul>
          <li class="flex items-center">
            <NuxtLink :to="localePath({ name: 'Settings' })" class="group/link flex items-center">
              <IconGearwheel class="w-18 shrink-0 px-5.5 py-2" />
              <h2
                class="text-base font-bold tracking-wide underline-offset-2 opacity-0 transition-opacity duration-300 group-open:opacity-100 group-hover/link:underline">
                {{ $t('navigate.settings') }}
              </h2>
            </NuxtLink>
          </li>
        </ul>
      </div>
    </menu>
  </div>
</template>

<script lang="ts" setup>

defineProps<{
  searchOpen: boolean
}>()

const { t } = useI18n()
const { locale: currentLocale } = useI18n()
const localePath = useLocalePath()
const route = useRoute()


const open = ref(false)


import { graphql } from 'gql.tada'
import { useQuery } from '@urql/vue'

const router = useRouter()
const isMainPage = computed(() => {
  return router.currentRoute.value.meta.name === 'index'
})

const result = await useQuery({
  query: graphql(`
    query Nav($site: String!) {
      nav(handle: "general_information_nav") {
        tree(site: $site) {
          page {
            url
            title
            id
            ... on NavEntryPage_GeneralInformationNav_GeneralInformation_GeneralInformation {
              id
              slug
            }
          }
        }
      }
    }
  `),
  variables: { site: currentLocale },
})
useFailOnError(result.error)

const nav = result.data?.value?.nav

const genID = (slug: string) => {
  return '#section-' + slug
}
</script>
